(function(){
  var unitPrice = window.ORAK_STD_PRICE || 0;
  var stock = (typeof window.ORAK_STD_STOCK === 'number') ? window.ORAK_STD_STOCK : null; // stock réel (null = illimité)
  var cap   = (typeof window.ORAK_STD_CAP === 'number')   ? window.ORAK_STD_CAP   : null; // plafond par commande (null = aucun)

  // Plafond effectif = le plus petit entre le stock réel et le plafond commande.
  function effMax(){
    var m = Infinity;
    if(stock !== null && stock >= 0) m = Math.min(m, stock);
    if(cap   !== null && cap   >= 0) m = Math.min(m, cap);
    return (m === Infinity) ? null : m;
  }

  // ── STOCK / PLAFOND : deux messages distincts ────────────────
  // - Si le plafond commande est la contrainte (stock réel > 50) : message « max 50 par commande ».
  // - Sinon (stock réel <= 50, ou stock réel = 50 pile) : message « seulement N disponibles ».
  function showStockMsg(){
    var box = document.getElementById('qtyStockMsg');
    var txt = document.getElementById('qtyStockMsgTxt');
    if(!box || !txt) return;
    var useCap = (cap !== null) && (stock === null || cap < stock);
    var tpl, cnt;
    if(useCap){ tpl = window.ORAK_STD_CAP_MSG || 'Commande limitée à %count% unités par commande.'; cnt = cap; }
    else      { tpl = window.ORAK_STD_STOCK_MSG || 'Stock limité : %count%.'; cnt = stock; }
    txt.textContent = tpl.replace('%count%', cnt);
    box.hidden = false;
  }
  function hideStockMsg(){
    var box = document.getElementById('qtyStockMsg');
    if(box) box.hidden = true;
  }
  // Ramène val au plafond effectif si dépassé et affiche/masque le message. Renvoie la valeur retenue.
  function clampToStock(val){
    var m = effMax();
    if(m === null){ hideStockMsg(); return val; }
    if(val > m){ showStockMsg(); return m; }
    hideStockMsg();
    return val;
  }

  // ── QTY + TOTAL ──────────────────────────────────────────────
  function changeQty(delta){
    var inp = document.getElementById('qtyInput');
    if(!inp) return;
    var val = (parseInt(inp.value) || 1) + delta;
    if(val < 1) val = 1;
    val = clampToStock(val);
    inp.value = val;
    updateTotal();
  }

  function updateTotal(){
    var inp = document.getElementById('qtyInput');
    var tot = document.getElementById('totalEstimate');
    if(!inp || !tot) return;
    var qty = parseInt(inp.value) || 0;
    var total = (qty * unitPrice).toFixed(2).replace('.', ',');
    tot.textContent = total + ' €';
  }

  var qtyInput = document.getElementById('qtyInput');
  if(qtyInput){
    qtyInput.addEventListener('input', function(){
      var v = parseInt(this.value);
      var m = effMax();
      if(!isNaN(v) && m !== null && v > m){ showStockMsg(); } else { hideStockMsg(); }
      updateTotal();
    });
    qtyInput.addEventListener('blur', function(){
      var v = parseInt(this.value);
      if(isNaN(v) || v < 1) v = 1;
      this.value = clampToStock(v);
      updateTotal();
    });
  }
  updateTotal();

  // ── GALLERY THUMBS ───────────────────────────────────────────
  function setThumb(el, src){
    document.querySelectorAll('.thumb').forEach(function(t){ t.classList.remove('active'); });
    el.classList.add('active');
    var main = document.getElementById('mainImg');
    if(main && src){ main.src = src; }
  }

  // ── ADD TO CART (AJAX → drawer) ──────────────────────────────
  var form = document.getElementById('product-form-standard');
  if(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var variantId = idInput ? idInput.value : (window.ORAK_STD_VARIANT_ID || '');
      if(!variantId) return;

      var qtyEl = document.getElementById('qtyInput');
      var qty = parseInt(qtyEl && qtyEl.value) || 1;
      if(qty < 1) qty = 1;
      // Ne jamais demander plus que le stock réel : on plafonne et on prévient.
      var capped = clampToStock(qty);
      if(capped !== qty){ qty = capped; if(qtyEl) qtyEl.value = qty; }

      var btn = form.querySelector('.btn-add');
      if(btn){ btn.disabled = true; }

      if(window.CartDrawer){
        CartDrawer.addItem(variantId, qty, {});
        setTimeout(function(){ if(btn){ btn.disabled = false; } }, 1200);
      } else {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        }).then(function(){ window.location.href = (window.ORAK_ROOT || '') + '/checkout'; })
          .catch(function(){ if(btn){ btn.disabled = false; } });
      }
    });
  }

  // ── EXPOSE GLOBALS ───────────────────────────────────────────
  window.changeQty   = changeQty;
  window.updateTotal = updateTotal;
  window.setThumb    = setThumb;
})();
